import React from 'react';
import { View } from '@react-pdf/renderer';
const CardItemExteriorColor = ({ colorHexValue }) => {
    if (!colorHexValue)
        return null;
    return (React.createElement(View, { style: {
            backgroundColor: colorHexValue,
            width: '100%',
            height: '100%',
        } }));
};
export default CardItemExteriorColor;
